// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

// Your Firebase config from Firebase Console
// Go to Project Settings -> General -> Your apps -> Firebase SDK snippet -> Config
const firebaseConfig = {
  apiKey: "AIzaSyCoNiKsuXBV-sbLmEfXw9_V0FQIWDbAnhg",
  authDomain: "tradehawk-trading-bot.firebaseapp.com",
  projectId: "tradehawk-trading-bot",
  storageBucket: "tradehawk-trading-bot.firebasestorage.app",
  messagingSenderId: "567942316373",
  appId: "1:567942316373:web:0be45c98726bc2a80defdc",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export default app;
